(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-external-page-redirect"]) return;
  try {
    
  document.querySelectorAll('[data-cw-external-page-redirect]').forEach((redirect) => {
    const destination = redirect.dataset.cwExternalPageRedirect;

    if (destination && destination !== window.location.href) {
      window.location.replace(destination);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
